module.exports = __webpack_public_path__ + "img/avatar-2.6ea4af91.jpg";